module.exports = "<div class=\"wave-loader\">\n  <div class=\"layer-1\"></div>\n  <div class=\"layer-2\"></div>\n  <div class=\"layer-3\"></div>\n  <div class=\"layer-4\"></div>\n  <div class=\"layer-5\"></div>\n  <div class=\"layer-6\"></div>\n  <div class=\"layer-7\"></div>\n  <div class=\"layer-8\"></div>\n  <div class=\"layer-9\"></div>\n  <div class=\"layer-10\"></div>\n</div>\n\n<style>\n  body{\n    background: #1c1c1c !important;\n  }\n</style>"


//////////////////
// WEBPACK FOOTER
// C:/git/SynergiPartners 7-Eleven Screening/src/app/loader/loader.component.html
// module id = ../../../../../src/app/loader/loader.component.html
// module chunks = main